<template>
  <div>
    <toolbar />
    <v-row no-gutters>
      <v-col sm="12" md="6">
        <v-sheet :height="hoogte" class="primary">
          <div class="pt-8"></div>
          <v-img
            contain
            max-height="30vh"
            :src="
              require(`@/assets/core/logo_${
                $vuetify.theme.dark ? 'light' : 'dark'
              }.png`)
            "
          />

          <div class="text-center secondary--text">
            <h1 class="mt-6">{{ $t("login.welcome") }}</h1>
            <h3 class="mt-6 mb-6">{{ $t("login.color") }}</h3>
            <v-btn class="secondary" @click="toggle_dark_mode">
              <v-icon left>mdi-theme-light-dark</v-icon>
              <span>{{ $t("login.dark") }}</span>
            </v-btn>
          </div>
        </v-sheet>
      </v-col>
      <v-col sm="12" md="6" class="d-flex justify-center align-center">
        <v-card-text>
          <ValidationObserver
            ref="obs"
            v-slot="{ invalid, validated, handleSubmit }"
          >
            <v-form ref="form">
              <BaseValInput
                rules="required"
                v-model.trim="name"
                label="Gebruikersnaam"
              />
              <div class="text-end mr-15">
                <v-btn
                  color="primary"
                  @click="handleSubmit(login)"
                  :disabled="invalid || !validated"
                  >{{ $t("login.login") }}</v-btn
                >
              </div>
            </v-form>
          </ValidationObserver>
          <FlashMessage :error="error" v-if="error" key="error" />
        </v-card-text>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getError } from "@/utils/helpers";
import { ValidationObserver } from "vee-validate";
import BaseValInput from "@/components/input/BaseValInput";
import AuthService from "@/services/AuthService";
import FlashMessage from "@/components/input/FlashMessage";
import Toolbar from "@/components/navigation/Toolbar";

export default {
  name: "Login",
  components: {
    Toolbar,
    BaseValInput,
    ValidationObserver,
    FlashMessage,
  },

  data() {
    return {
      valid: false,
      theme: null,
      name: null,
      password: 'password',
      error: null,
    };
  },
  methods: {
    lowercase() {
      this.email = this.email.toLowerCase();
    },
    toggle_dark_mode: function () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
    },
    async login() {
      const payload = {
        name: this.name,
        password: this.password,
      };
      this.error = null;
      try {
        await AuthService.login(payload);
        const authUser = await this.$store.dispatch("auth/getAuthUser");
        if (authUser) {
          this.$store.dispatch("auth/setGuest", { value: "isNotGuest" });
          await AuthService.twofa(payload);
          this.$router.push("/twofactor");
        } else {
          const error = Error(
            "Unable to fetch user after login, check your API settings."
          );
          error.name = "Fetch User";
          throw error;
        }
      } catch (error) {
        this.error = getError(error);
      }
    },
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    hoogte() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "100vh";
        case "sm":
          return "40vh";
        case "md":
          return "100vh";
        case "lg":
          return "100vh";
        case "xl":
          return "100vh";
      }
    },
  },
  mounted() {
    const theme = localStorage.getItem("dark_theme");
    if (theme) {
      this.$vuetify.theme.dark = theme === "true";
    }
  },
};
</script>

<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal !important; /* maybe !important  */
}

.height-col {
  height: 100vh;
}
</style>
